import { useEffect, useState } from "react";
import { Container, Row, Col, Input, Card, CardBody } from "reactstrap";
import { getData } from "../../../CommonElements/Functions/PostGetFun";
import { API } from "../../../api/API";
import { dynamicImage } from "../../../Utils";
import { H4, Image, LI, ProgressBar, UL } from "../../../AbstractElements";
import CommonTableNew from "../../Tables/ReactstrapTables/BasicTables/Common/CommonTableNew";
import FeatherIconCom from "../../../Utils/CommonComponents/CommonIcons/FeatherIconCom";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import CardHeaderSpan from "../../../Utils/CommonComponents/CardHeaderSpan";
import { ensureDexieReady, getDataFromDexie } from "../../../db/DexieServises";
import SvgIcon from "../../../Utils/CommonComponents/CommonIcons/CommonSvgIcons";

export default function FtpExportLogs() {
    const [ftpExportLogs, setFtpExportLogs] = useState<any[]>([]);
    const [searchText, setSearchText] = useState('');
    const [displayedData, setDisplayedData] = useState<any[]>([]);
    const [loading, setLoading] = useState(true);

    const serverUrl = localStorage.getItem('serverUrl');
    const APP_TOKEN = localStorage.getItem('appToken');
    const formatDateTime = (dateTimeString: string | null) => {
        if (!dateTimeString) return 'N/A';
        const date = new Date(dateTimeString);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const seconds = String(date.getSeconds()).padStart(2, '0');
        return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
    };

    const ftpExportCardData = ftpExportLogs.map((item) => ({
        id: item.FtpExportLogId,
        color: item.HasError ? 'danger' : 'primary',
        icon: 'improvement',  // any icon you use
        title: `File: ${item.FilePath.split('/').pop()}`,
        text: item.FilePath,
        comment: [
            { id: 1, spanText: `Created: ${formatDateTime(item.CreatedAt)}` },
            { id: 2, spanText: `Processed Records: ${item.NoProcessedRecords}` },
            { id: 3, spanText: `Start: ${formatDateTime(item.StartTime)}` },
            { id: 4, spanText: `End: ${formatDateTime(item.EndTime)}` },
            { id: 5, spanText: `From: ${item.ExportStartDate}` },
            { id: 6, spanText: `To: ${item.ExportEndDate}` },
            { id: 7, spanText: item.IsFileProcessing ? 'Processing...' : 'Completed' },
            { id: 8, spanText: item.HasError ? 'Error Found' : 'No Error' },
        ],
        progressValue: item.NoProcessedRecords ? 100 : 0,
    }));

    useEffect(() => {
        fetchLogs();
    }, []);

    const fetchLogs = async () => {
        if (!serverUrl || !APP_TOKEN) {
            console.error('❌ Missing server URL or APP_TOKEN');
            return;
        }
        await ensureDexieReady();
        const orgdata = await getDataFromDexie('OrgUnit');
        const companyId = orgdata?.[0]?.CompanyId;
        // console.log(companyId, '===============OrgUnit-> companyId ');

        setLoading(true);
        try {
            const url = `${serverUrl}${API.getFtpExportLogs}`;
            const { status, data } = await getData(url, true, { company_id: companyId });

            if (status === 200 && Array.isArray(data?.data)) {
                setFtpExportLogs(data.data);
                setDisplayedData(data.data);
            } else {
                setFtpExportLogs([]);
                setDisplayedData([]);
            }
        } catch (error) {
            console.error("❌ Failed to fetch FTP Export Logs:", error);
            setFtpExportLogs([]);
            setDisplayedData([]);
        } finally {
            setLoading(false);
        }
    };

    const keys = ftpExportLogs.length > 0 ? Object.keys(ftpExportLogs[0]) : [];
    const headData = keys.map((key, index) => ({
        id: `${index + 1}`,
        head: key,
        key: key,
        sortKey: key
    }));

    // 🔍 Search Logic
    useEffect(() => {
        const lower = searchText.toLowerCase();
        const filtered = ftpExportLogs.filter((item) =>
            keys.some(k => String(item[k])?.toLowerCase().includes(lower))
        );
        setDisplayedData(filtered);
    }, [searchText, ftpExportLogs]);

    // ⬇️ Export Logic
    const handleExportToExcel = () => {
        const exportData = displayedData.map((row: Record<string, any>) => {
            const rowData: Record<string, any> = {};
            keys.forEach(key => {
                rowData[key] = row[key];
            });
            return rowData;
        });

        const worksheet = XLSX.utils.json_to_sheet(exportData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'FTP Export Logs');

        const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
        saveAs(blob, `FTP_Export_Logs_${new Date().toISOString().split("T")[0]}.xlsx`);
    };

    return (
        <div className="">
            <Container fluid className="project-dashboard pb-2 pt-2">
                {/* <CardHeaderSpan headingClassName='pb-2 pt-0' back={true} heading={'FTP '} span={'ReportListTitle'} /> */}
                <Col xl={12} className="col-xl-100 box-col-12">
                    <Row>
                        {ftpExportCardData.map((item) => (
                            <Col xl={4} lg={4} key={item.id}>
                                <Card className="web-card">
                                    <CardBody>
                                        <div className={`d-flex`}>
                                            <div className="header-top">
                                                <div className={`mobile-app bg-light-${item.color}`}>
                                                    <span></span>
                                                    <SvgIcon iconId={item.icon} />
                                                </div>
                                                <div className="flex-grow-1">
                                                    <H4>{item.title}</H4>
                                                    <span>{item.text}</span>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="comment">
                                            <UL className='simple-list flex-row flex-wrap ' style={{ gap: '10px' }}>
                                                {item.comment.map((list) => (
                                                    <LI key={list.id} style={{ whiteSpace: 'wrap' }}>
                                                        <span>{list.spanText}</span>
                                                    </LI>
                                                ))}
                                            </UL>

                                        </div>

                                        <div className="col-12">
                                            <div className="progress-value">
                                                <div className='d-flex justify-content-between'>
                                                    <span>Progress</span>
                                                    <span>{item.progressValue}%</span>
                                                </div>
                                                <ProgressBar value={item.progressValue} color={item.color} />
                                            </div>
                                        </div>
                                    </CardBody>
                                </Card>
                            </Col>
                        ))}
                    </Row>
                </Col>
            </Container>



            {/* <Container fluid>
                <CardHeaderSpan headingClassName='pb-2 pt-0' back={true} heading={'FTP Export Logs'} span={'ReportListTitle'} />

                <Row className="align-items-center justify-content-between mb-3">
                    <Col md="4">
                        <Input
                            type="text"
                            value={searchText}
                            onChange={(e) => setSearchText(e.target.value)}
                            placeholder="🔍 Search Logs"
                        />
                    </Col>

                    <Col md="auto">
                        <button className="btn btn-sm btn-primary d-flex align-items-center" onClick={handleExportToExcel}>
                            <FeatherIconCom iconName="Download" size={14} className="text-light" />
                            <span className="px-2" style={{ fontSize: 14 }}>Export</span>
                        </button>
                    </Col>
                </Row>

                {loading ? (
                    <div className="text-center py-3">
                        <Image
                            className="b-r-10 img-80"
                            src={dynamicImage('dashboard/loader.gif')}
                            alt="Loading..."
                        />
                    </div>
                ) : (
                    <CommonTableNew
                        caption=""
                        headData={headData}
                        data={displayedData}
                        renderRow={(row, rowIndex) => (
                            <tr key={rowIndex}>
                                {keys.map((key, colIndex) => (
                                    <td key={colIndex}>{row[key]}</td>
                                ))}
                            </tr>
                        )}
                    />
                )}
            </Container> */}
        </div>
    );
}
